/*
 * @Author: lixiao
 * @Date: 2020-08-09 14:26:36
 * @Description: 公共部分
 */
// import { fetchPost, fetchGet, fetchPut, fetchDel } from '@cloudscope/cs-assembly';
import { fetchPost, fetchGet, fetchPut, fetchDel } from '@/axios';
const Common = {
    /**
         * @author: lixiao
         * @description: 登录接口、密码加密公钥以及验证码等接口
         * @param {type}
         */
    Login (param, Headers) {
        return fetchPost('/api/v1/auth/oauth/token', param, Headers);
    },
    getCode () {
        return fetchGet('/api/v1/auth/code/getCode');
    },
    getNum (username) {
        return fetchGet('/api/v1/auth/code/getNum', {username});
    },
    getPasswordKey () {
        return fetchGet('/api/auth/devcorp_api/user/getKey');
    },
    current (type) {
        if (type === 'system') {
            return fetchGet('/api/auth/devcorp_api/user/current');
        } else {
            return fetchGet('/api/auth/devcorp_api/user/current');
        }
    },
    /**
     * @author: zhang
     * @description: 切换团队
     * @param {} {*}
     */
    switchTenant (tenantId) {
        return fetchPost(`/api/auth/frontmodule/authRegisterUser/switch-tenant?tenantId=${tenantId}`);
    },
    /**
     * @author: zhang
     * @description: 获取菜单
     * @param {} {*}
     */
    listMenuByRoleId (registerUserId, tenantId, userFlag) {
        if (userFlag) {
            return fetchPost(`/api/auth/listBackMenuByRoleId?userId=${registerUserId}`);
        } else {
            return fetchPost(`/api/auth/listMenuByRoleId?registerUserId=${registerUserId}&tenantId=${tenantId}`);
        }
    },
    /**
     * @author: liuc
     * @description: 获取当前人信息
     */
    getCurrentUserInfo () {
        return fetchGet('/api/auth/frontmodule/authRegisterUser/current-user-info');
    }
};
export default Common;



// WEBPACK FOOTER //
// ./src/services/Common.js